module.exports = __webpack_public_path__ + "static/media/pmv_red_circle.4a8b19e2.svg";